import React from 'react'
import PublicPageSF from '../../templates/PublicPageSF'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import ContentUI from '../../widgets/output/ContentUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'

const TermsPageUI = ({context, terms, messageList}) =>
  <PublicPageSF context={context} className='pg_terms' backLink='/'
    messageList={messageList} headerMessageKey='c_terms'
    centered={!terms}
  >
    {
      !terms &&
      <SpinnerComponentUI />
    }
    {
      terms &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/'
          messageList={messageList} titleMessageKey='c_terms'
        />
        <ContentUI context={context} content={terms}/>
      </div>
    }
  </PublicPageSF>

export default TermsPageUI
